// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-footer{width:100%;padding:0;position:relative;height:35px;display:flex}.page-footer .footer-copyright{border-top:1px solid #ccc;width:100%;display:flex;text-align:center}.page-footer.side-bar-visible{margin-left:3.2rem}\n", ""]);
// Exports
module.exports = exports;
